module.exports = __webpack_public_path__ + "img/edit_user_tags_save.d7bcb720.png";